export default "__VITE_ASSET__a36dbd56__"